"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ClickAwayListener.default;
  }
});

var _ClickAwayListener = _interopRequireDefault(require("./ClickAwayListener"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ClickAwayListener/index.js
// module id = 204
// module chunks = 114276838955818